// extracted by mini-css-extract-plugin
export default {"iframe":"DMR__iframe--1yfbT"};